import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';

import { IContact } from '../../../../../type_definitions/datatypes';

export interface IMasterCatalogDetail {
  validityDate?: number | Date;
  owner?: IContact;
  title?: string;
  totalProducts?: number;
  modifiedBy: IContact;
  modificationDate: number | Date;
  webshopId: number;
  catalogId?: number;
}

@Injectable()
export class BPProfilesProductCatalogDataService {
  constructor(
    private httpDataService: HttpDataService
  ) {
    /**/
  }

  public getMasterCatalogDetail(profileId: string): Promise<IMasterCatalogDetail> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/catalog`,
      {},
      undefined,
      'Error loading master catalog detail'
    );
  }
}